<template>
  <div class="permission-row permission-tree">
    <UiCheckbox
      v-model="teammatesAffiliatesActive"
      :disabled="disabled"
      :label="$t('permissions.teammates_affiliates')"
      class="permission-tree__checkbox"
    />
    <div class="field permission-tree__branch">
      <UiRadioGroup
        v-model="teammatesAffiliatesType"
        class="t:w-full"
        :disabled="!teammatesAffiliatesActive || disabled"
        :options="[
          {
            label: $t('permissions.allow_all'),
            value: 'teammates_affiliates',
          },
          {
            label: $t('permissions.allow_selected'),
            value: 'teammates_affiliates_only_selected',
          },
          {
            label: $t('permissions.deny_selected'),
            value: 'teammates_affiliates_except_selected',
          }
        ]"
      >
        <UiSelectElement
          :model-value="pTeammatesIds"
          :placeholder="$t(`permissions.add_teammates`)"
          :list="usersList || []"
          size="big"
          search-param="email"
          option-label-param="email"
          option-name-param="email"
          filterable
          multiple
          collapse-tag-tooltip
          :max-collapse-tags="1"
          :disabled="!teammatesAffiliatesActive || teammatesAffiliatesType === 'teammates_affiliates' || disabled"
          @update:model-value="$emit('update:teammatesIds', $event )"
        />
      </UiRadioGroup>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PermissionTree',

  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    affiliatesTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    teammatesIds: {
      type: Array,
      default() {
        return [];
      },
    },
    usersList: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: ['update:teammatesIds'],
  data() {
    return {
      teammatesAffiliatesActive: false,
      teammatesAffiliatesType: '',
      modeArray: ['teammates_affiliates', 'teammates_affiliates_only_selected', 'teammates_affiliates_except_selected'],
    };
  },

  computed: {
    pTeammatesIds() {
      return this.usersList === null ? [] : this.teammatesIds;
    },
  },

  watch: {
    affiliatesTypes: {
      handler(value) {
        const curAffiliatesTypes = Array.isArray(value) ? this.$_.cloneDeep(value) : [];
        const intersection = this.modeArray.filter((modeItem) => curAffiliatesTypes.includes(modeItem));
        if (intersection.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          this.teammatesAffiliatesType = intersection[0];
          this.teammatesAffiliatesActive = true;
        } else {
          this.teammatesAffiliatesActive = false;
        }
      },
      immediate: true,
    },
    teammatesAffiliatesType: {
      handler(value) {
        this.clear();
        if (value) {
          this.affiliatesTypes.push(value);
          if (value === 'teammates_affiliates') {
            this.$emit('update:teammatesIds', []);
          }
        }
      },
      immediate: true,
    },
    teammatesAffiliatesActive: {
      handler(value) {
        if (!value) {
          this.teammatesAffiliatesType = '';
          this.$emit('update:teammatesIds', []);
        } else if (!this.teammatesAffiliatesType) {
          this.teammatesAffiliatesType = 'teammates_affiliates';
        }
      },
      immediate: true,
    },
  },

  methods: {
    clear() {
      this.modeArray.forEach((item) => {
        const index = this.affiliatesTypes.indexOf(item);
        if (index >= 0) {
          this.affiliatesTypes.splice(index, 1);
        }
      });
    },
  },
};

</script>
